// Lightweight CSV serializer + browser download.

function escapeCell(value) {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function toCSV(rows, columns) {
  if (!rows || rows.length === 0) return "";
  const cols = columns || Object.keys(rows[0]);
  const header = cols.map((c) => escapeCell(c.label || c.key || c)).join(",");
  const body = rows
    .map((row) =>
      cols
        .map((c) => {
          const key = c.key || c;
          let v = row[key];
          if (typeof c.format === "function") v = c.format(v, row);
          return escapeCell(v);
        })
        .join(","),
    )
    .join("\n");
  return `${header}\n${body}\n`;
}

export function downloadCSV(filename, rows, columns) {
  const csv = toCSV(rows, columns);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function formatPct(value) {
  if (value === null || value === undefined) return "";
  return `${(value * 100).toFixed(1)}%`;
}

export function formatEuro(value) {
  if (value === null || value === undefined) return "";
  return `€${Number(value).toLocaleString("en-US")}`;
}

export function formatCurrency(value, currency = "EUR") {
  if (value === null || value === undefined) return "";
  const symbols = { EUR: "€", USD: "$", GBP: "£" };
  const sym = symbols[currency] || `${currency} `;
  return `${sym}${Number(value).toLocaleString("en-US")}`;
}
